import React from "react";
import styled from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
var Wrapper = styled.div.withConfig({
  componentId: "sc-1dg6h8v-0"
})(["display:grid;grid-gap:", ";", "{grid-gap:", ";}", "{grid-template-columns:1fr 1fr;> *:nth-child(odd):last-child{grid-column:1 / -1;}}"], space(2), breakpoint("medium"), space(4), breakpoint("huge"));
var TilesOrg = function TilesOrg(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Wrapper, null, children);
};
export default TilesOrg;